// importing packages
// import Lesson from '../../assets/logo.svg'
// import img2 from '../../assets/react.svg'
import eng1 from '../../assets/eng1.png'
import eng2 from '../../assets/eng2.png'
import eng3 from '../../assets/eng3.png'
import math1 from '../../assets/math1.png'
import math2 from '../../assets/math2.png'
import math3 from '../../assets/math3.png'
import phy from '../../assets/phy.png'
import chem from '../../assets/chem.png'
import bio from '../../assets/bio.png'
import gov from '../../assets/gov.png'
import econs from '../../assets/econs.png'
import comp1 from '../../assets/comp1.png'
import comp2 from '../../assets/comp2.png'
import comp3 from '../../assets/comp3.png'

// ss1 materials

// first assets
export const first = [
  {
    id: 1,
    image: eng1,
    title: 'English',
    url: 'ss1eng',
  },
  {
    id: 2,
    image: math1,
    title: 'Maths',
    url: 'ss1math',
  },
  {
    id: 3,
    image: phy,
    title: 'Physics',
    url: 'ss1phy',
  },
  {
    id: 4,
    image: bio,
    title: 'Biology',
    url: 'ss1bio',
  },
  {
    id: 5,
    image: chem,
    title: 'Chemistry',
    url: 'ss1chem',
  },
  {
    id: 6,
    image: gov,
    title: 'Government',
    url: 'ss1gov',
  },
  {
    id: 7,
    image: econs,
    title: 'Economics',
    url: 'ss1econs',
  },
  {
    id: 8,
    image: comp1,
    title: 'Computer',
    url: 'ss1comp',
  },
]

export const ss1VideoEng1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/eub0Q2KzV-I',
    title: 'Class 1: Vowel Sound',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/SceDmiBEESI',
    title: 'Class 2: Parts of Speech.',
  },
]

export const ss1VideoMath1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/ctqviXu-mTE',
    title: 'Class 1: Factorization.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/r59oLimduIM',
    title: 'Class 2: Simultaneous Equation.',
  },
]

export const ss1VideoPhy1 = [
  {
    id: 1,
    video:
      'https://www.youtube.com/embed/cdvL8wckpfI?list=PL1JHDIvuvb4AOMaXKn4tcrsJ6H104F3ZS',
    title: 'Class 1: Overview of Physics.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/cmb1LbI6BgU',
    title: 'Class 2: Measurements.',
  },
]

export const ss1VideoChem1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/4ekf0J-W5k0',
    title: 'Class 1: Branches of Chemistry.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/SVONb8IBXVQ',
    title: 'Class 2: Liquid Light - Chemical Reaction with Luminol.',
  },
]

export const ss1VideoBio1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Class 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Class 2: Habitat.',
  },
]

export const ss1VideoEcons1 = [
  {
    id: 1,
    video:
      'https://www.youtube.com/embed/wCHm5SdNO5U?list=PLSQl0a2vh4HDERCw_ddanXbsDpFWcpL-S',
    title: 'Class 1: What is Economics.',
  },
  {
    id: 2,
    video: '',
    title: '',
  },
]

export const ss1VideoGov1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/n6mqRreNLr4',
    title: 'Class 1: What is Government.',
  },
  {
    id: 2,
    video: '',
    title: '',
  },
]

export const ss1VideoComp1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/XEWwOUvzWJ0',
    title: 'Class 1: What is Computer Science',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/AlqTPomaSLA',
    title: 'Class 2: Software Engineering',
  },
]

// ss1 Text
export const ss1TextEng1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss1TextMath1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss1TextPhy1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss1TextBio1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss1TextChem1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss1TextEcons1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss1TextGov1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss1TextComp1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]
// =======================================================
// ss2 materials
// ss2 assets
export const second = [
  {
    id: 1,
    image: eng2,
    title: 'English',
    url: 'ss2eng',
  },
  {
    id: 2,
    image: math2,
    title: 'Maths',
    url: 'ss2math',
  },
  {
    id: 3,
    image: phy,
    title: 'Physics',
    url: 'ss2phy',
  },
  {
    id: 4,
    image: bio,
    title: 'Biology',
    url: 'ss2bio',
  },
  {
    id: 5,
    image: chem,
    title: 'Chemistry',
    url: 'ss2chem',
  },
  {
    id: 6,
    image: gov,
    title: 'Government',
    url: 'ss2gov',
  },
  {
    id: 7,
    image: econs,
    title: 'Economics',
    url: 'ss2econs',
  },
  {
    id: 8,
    image: comp2,
    title: 'Computer',
    url: 'ss2comp',
  },
]

export const ss2VideoEng1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss2VideoMath1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss2VideoPhy1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss2VideoChem1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss2VideoBio1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss2VideoEcons1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss2VideoGov1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss2VideoComp1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

// ss1 Text
export const ss2TextEng1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss2TextMath1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss2TextPhy1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss2TextBio1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss2TextChem1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss2TextEcons1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss2TextGov1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss2TextComp1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

// =====================================================
// ss3 materials
// ss3 assets
export const third = [
  {
    id: 1,
    image: eng3,
    title: 'English',
    url: 'ss3eng',
  },
  {
    id: 2,
    image: math3,
    title: 'Maths',
    url: 'ss3math',
  },
  {
    id: 3,
    image: phy,
    title: 'Physics',
    url: 'ss3phy',
  },
  {
    id: 4,
    image: bio,
    title: 'Biology',
    url: 'ss3bio',
  },
  {
    id: 5,
    image: chem,
    title: 'Chemistry',
    url: 'ss3chem',
  },
  {
    id: 6,
    image: gov,
    title: 'Government',
    url: 'ss3gov',
  },
  {
    id: 7,
    image: econs,
    title: 'Economics',
    url: 'ss3econs',
  },
  {
    id: 8,
    image: comp3,
    title: 'Computer',
    url: 'ss3comp',
  },
]

export const ss3VideoEng1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss3VideoMath1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss3VideoPhy1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss3VideoChem1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss3VideoBio1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss3VideoEcons1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss3VideoGov1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

export const ss3VideoComp1 = [
  {
    id: 1,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    video: 'https://www.youtube.com/embed/8hve_WX9TF4',
    title: 'Week 1: Habitat.',
  },
]

// ss1 Text
export const ss3TextEng1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss3TextMath1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss3TextPhy1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss3TextBio1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss3TextChem1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss3TextEcons1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss3TextGov1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]

export const ss3TextComp1 = [
  {
    id: 1,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
  {
    id: 2,
    text: 'https://fctemis.org/notes/1024_habitat%20and%20adaptation.pdf',
    title: 'Week 1: Habitat.',
  },
]
